import {WixSdk} from '@wix/js-sdk-wrapper';
import {safe} from '@wix/music-shared/dist/src/utils/functions/safe/safe';

const steps = [
  'page-loaded',
  'document-ready',
  'style-params-loaded',
  'collection-loaded',
  'big-chunk-loaded',
  'initial-data-loaded',
  'init-raw-start',
  'init-raw-got-data',
  'chunk-loaded',
  'settings-loaded',
  'legacy-loaded',
  'init-called',
  'transform-finished',
  'styles-added',
  'app-mounted',
  'internal-inited',
  'player-started',
  'app-rendered',
  'inited',
];
const timings = new Map<string, number>();
const previosEvents = new Map<string, number>();
const performanceAvailable =
  typeof performance !== 'undefined' &&
  typeof performance.mark === 'function' &&
  typeof performance.measure === 'function';

export const reportPerformanceStep = safe(function (stepName: string, details: any = {}) {
  const stepNumber = steps.indexOf(stepName);
  if (previosEvents.has(stepName)) {
    return;
  }
  if (!previosEvents.has(stepName)) {
    performanceAvailable && performance.mark(`step: ${stepName}`);
  }
  previosEvents.set(stepName, Date.now());
  WixSdk.Performance.applicationLoadingStep(stepNumber, stepName);

  const currentTime = Date.now();
  previosEvents.set(stepName, currentTime);
  const {durationSince = steps[getPreviousStepNumber(stepNumber)]} = details;

  if (typeof performance !== 'undefined' && typeof performance.now === 'function') {
    timings.set(stepName, performance.now());
  }
  if (durationSince) {
    performanceAvailable && performance.measure(stepName, `step: ${durationSince}`, `step: ${stepName}`);
  }
  if (stepName === 'inited') {
    performanceAvailable && performance.measure('widget-init', `step: page-loaded`, `step: ${stepName}`);
  }
});

function getPreviousStepNumber(stepNumber: number): number {
  const prev = stepNumber - 1;
  return previosEvents.has(steps[prev]) ? prev : prev > 0 ? getPreviousStepNumber(prev) : 0;
}
